<template>
    <v-text-field v-model="searchValue" outlined clearable hide-details placeholder="상품명을 입력해 주세요." @keydown.enter="search">
        <template #append-outer>
            <v-btn x-large icon class="mr-n12" @click="search"><v-icon size="26">search</v-icon></v-btn>
        </template>
    </v-text-field>
</template>

<script>
export default {
    props: {
        value: { type: String, default: null },
    },
    data: () => ({
        searchValue: null,
    }),
    mounted() {
        this.sync();
    },
    watch: {
        searchValue() {
            this.emit();
        },
    },
    methods: {
        sync() {
            this.searchValue = this.value;
        },
        emit() {
            this.$emit("input", this.searchValue);
        },
        search() {
            this.$emit("search");
        },
    },
};
</script>

<style>
</style>